export default __webpack_public_path__ + "static/media/info3.ca8c1b8a.svg";